import appStoreBadge from "./assets/store-badges/apple/app-store-badge.svg";
import googlePlayEnglish from "./assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_English.svg";
import googlePlayRussian from "./assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Russian.svg";
import ruStoreBadge from "./assets/store-badges/rustore/rustore-badge-ru.svg";

export type StoreBadgeLanguage = "en" | "ru";

export const APP_STORE_BADGE = appStoreBadge;
export const RUSTORE_BADGE = ruStoreBadge;

export const GOOGLE_PLAY_BADGES: Record<StoreBadgeLanguage, string> = {
  en: googlePlayEnglish,
  ru: googlePlayRussian,
};
